import { useCallback, useEffect, useMemo } from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { inRn } from 'lib/helpers/utility';

export const useTableAutoHeight = ({ count }) => {
  const { gridApi, gridWrapperRef, limit, autoHeight } = useTableContext();

  const isSinglePage = useMemo(() => {
    return inRn(count) <= inRn(limit);
  }, [count, limit]);

  const setAutoHeight = () => {
    if (!gridApi) return;

    gridApi.setGridOption('domLayout', 'autoHeight');

    const wrapper = document.getElementById('myGrid');

    if (wrapper) {
      wrapper.style.height = 'auto';

      if (count === 0) {
        wrapper.style.height = '400px';
      }
    }
  };

  const setFixedHeight = useCallback(() => {
    if (!gridApi) return;
    gridApi.setGridOption('domLayout', 'normal');

    const wrapper = document.getElementById('myGrid');

    if (wrapper) {
      wrapper.style.height = '100%';
    }
  }, [gridApi, gridWrapperRef]);

  const measureAutoHeight = useCallback(() => {
    if (!gridApi || !autoHeight) return;

    const isAutoHeight = autoHeight && isSinglePage && inRn(limit) <= 10;
    if (isAutoHeight) {
      setAutoHeight();
    } else {
      setFixedHeight();
    }
  }, [gridApi, autoHeight, isSinglePage, setAutoHeight, setFixedHeight]);

  useEffect(() => {
    measureAutoHeight();
  }, [measureAutoHeight, isSinglePage, gridApi]);

  const isAutoHeight = Boolean(autoHeight && isSinglePage);

  return { isSinglePage, isAutoHeight };
};
